<template>
  <div class="section">
    <div class="container">
      <!-- Page Header -->
      <div class="mb-lg">
        <div class="columns is-vcentered">
          <div class="column is-one-third">
            <breadcrumbs :history="[{ label: 'Exceptions', name: 'exceptions.list'}]" current="Browse" />
          </div>
          <div class="column is-one-third">
            <h1 class="has-text-centered is-size-4">Exceptions</h1>
          </div>
        </div>
      </div>
      <!-- Filters Toolbar -->
      <div class="has-background-white rounded-lg pa-md mb-xxs">
        <div class="columns">
          <div class="column">
            <exception-filters :applied-filters="filters" @filter="filter" />
          </div>
          <div class="column is-narrow">
            <b-select v-model="orderBy" size="is-medium" expanded @input="sort">
              <option value="-id">Most Recent</option>
              <option value="id">Oldest</option>
            </b-select>
          </div>
        </div>
      </div>
      <!-- Actions Toolbar -->
      <div class="has-background-white rounded-lg px-md py-sm mb-xxs">
        <div class="columns is-vcentered is-mobile">
          <div class="column is-narrow">
            <b-dropdown :disabled="loading || selected.length === 0">
              <button class="button" slot="trigger" slot-scope="{ active }" :disabled="selected.length === 0">
                <span>Actions</span>
                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
              </button>
              <template v-if="context.isSupplier()">
                <b-dropdown-item has-link><a href="#" @click.prevent class="has-text-grey-light">No Actions</a></b-dropdown-item>
              </template>
              <template v-if="context.isMerchant()">
                <b-dropdown-item has-link><a href="#" @click.prevent class="has-text-grey-light">No Actions</a></b-dropdown-item>
              </template>
            </b-dropdown>
          </div>
          <div class="column">
            <div class="has-text-right is-size-7">
              <!-- Counts -->
              <p v-if="loading">Loading...</p>
              <p v-else>{{ total }} exceptions found.</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Results -->
      <div>
        <div class="mb-md">
          <b-table
            :data="results"
            :checked-rows.sync="selected"
            :mobile-cards="false"
            :loading="loading"
            hoverable
            checkable
            checkbox-position="left"
            class="is-size-7">
            <template>
              <!-- RC ID (since RMA Number not always required) -->
              <b-table-column
                label="ID"
                header-class="nowrap"
                cell-class="nowrap"
                width="96"
                v-slot="props">
                <a href="#"
                  class="has-text-weight-bold has-text-info"
                  @click.prevent="inspectException = props.row"
                >{{ props.row.id }}</a>
              </b-table-column>
              <!-- Module -->
              <b-table-column
                label="Module"
                header-class="nowrap"
                cell-class="nowrap"
                width="96"
                v-slot="props">
                {{ props.row.type.module }}
              </b-table-column>
              <!-- Resolved -->
              <b-table-column
                label="Resolved?"
                header-class="nowrap"
                cell-class="nowrap"
                centered
                width="96"
                v-slot="props">
                <span v-if="props.row.resolved_at !== null">{{ $dates.utc(props.row.resolved_at).format('MMM D') }}</span>
                <span v-else class="has-text-grey-light is-italic">--</span>
              </b-table-column>
              <!-- Truncated Message -->
              <b-table-column
                label="Message"
                header-class="nowrap"
                cell-class="nowrap"
                v-slot="props">
                {{ $utils.truncate(props.row.type.message, { length: 64 }) }}
              </b-table-column>
            </template>
            <template #empty>
              <div class="py-xxl has-text-grey has-text-centered">
                {{ (loading) ? "Loading data..." : 'No exceptions found!' }}
              </div>
            </template>
          </b-table>
        </div>
        <b-pagination
          :total="total"
          :current.sync="currentPage"
          :rounded="true"
          :per-page="perPage"
          @change="paginate">
        </b-pagination>
      </div>

      <!-- Inspect Exception -->
      <b-modal
        v-if="(inspectException !== null)"
        has-modal-card
        :active="(inspectException !== null)"
        :can-cancel="['escape', 'x']"
        @close="closeModals"
        ><ExceptionModal :selectedException="inspectException" />
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Filterable from '@/mixins/Filterable'
import ExceptionModal from '@/components/Modals/Exception/ExceptionModal'
import ExceptionFilters from '../components/List/ExceptionFilters'

export default {
  components: {
    ExceptionFilters,
    ExceptionModal
  },
  data () {
    return {
      key: 'exceptions',
      alwaysAttach: {
        skip_attributes: 1
      },
      // modals
      showExceptionModal: false,
      inspectException: null
    }
  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/exceptions/'
    }
  },
  methods: {
    closeModals () {
      this.inspectException = null
    },
    reload () {
      this.selected = []
      this.load()
    }
  },
  mounted () {
    this.load()
  },
  mixins: [Filterable]
}
</script>
